import { useMemo } from "react";
import { useStore } from "../data/store";
import { Bar, Btn, Stat } from "../ui/bits";
import { toFa } from "@soheil/core";
import { levelName, levelProgress } from "@soheil/core";
import { roomState, ROOM_ITEMS } from "@soheil/core";
import { isTelegram, telegramUser, platformName } from "../platform/telegram";
import { Upgrade } from "../ui/Upgrade";
import { PlusTools } from "../ui/PlusTools";

export function Settings() {
  const { state, dispatch } = useStore();
  const s = state.settings;
  const lp = useMemo(() => levelProgress(state.progress.totalStars), [state.progress.totalStars]);
  const room = useMemo(
    () => roomState(state.progress.longestStreak, state.progress.studyMinutes),
    [state.progress.longestStreak, state.progress.studyMinutes],
  );
  const tgUser = telegramUser();

  return (
    <div className="screen">
      <header className="daybar"><div><h1>من</h1><span>پیشرفت و تنظیمات</span></div></header>

      <section className="block">
        <div className="levelcard">
          <div className="levelcard-top">
            <b>{levelName(lp.level)}</b>
            <span>سطح {toFa(lp.level)}</span>
          </div>
          <Bar pct={lp.pct} />
          <span className="levelcard-sub">
            {toFa(lp.into)} از {toFa(lp.span)} ستاره تا سطح بعد
          </span>
        </div>
        <div className="stats-row">
          <Stat value={state.progress.totalStars} label="کل ستاره" tone="gold" />
          <Stat value={state.progress.currentStreak} label="زنجیره" tone="sage" />
          <Stat value={state.progress.longestStreak} label="رکورد" tone="lilac" />
          <Stat value={Math.round(state.progress.studyMinutes / 60)} label="ساعت مطالعه" tone="gold" />
        </div>
        {state.progress.freezeTokens > 0 && (
          <p className="hint">☁️ {toFa(state.progress.freezeTokens)} «شب ابری» داری — یک روز از دست رفته را می‌بخشد.</p>
        )}
      </section>

      <Upgrade />

      <PlusTools />

      <section className="block">
        <h2>اتاق سهیل</h2>
        <ul className="roomlist">
          {ROOM_ITEMS.map((it) => {
            const on = room.unlocked.includes(it.id);
            return (
              <li key={it.id} data-on={on ? "1" : "0"}>
                <span className="roomlist-ico">{it.emoji}</span>
                <div><b>{it.name}</b><span>{it.hint}</span></div>
                <em>{on ? "باز شد" : "قفل"}</em>
              </li>
            );
          })}
        </ul>
      </section>

      <section className="block">
        <h2>تنظیمات</h2>
        <label className="field">
          <span>اسمت</span>
          <input
            className="input"
            value={s.displayName}
            placeholder={tgUser?.first_name ?? "اختیاری"}
            onChange={(e) => dispatch({ type: "setSettings", patch: { displayName: e.target.value } })}
          />
        </label>
        <label className="field">
          <span>هدف روزانهٔ آب (لیوان)</span>
          <input
            className="input" type="number" min={1} max={20} value={s.waterGoal}
            onChange={(e) => dispatch({ type: "setSettings", patch: { waterGoal: Math.max(1, Number(e.target.value) || 8) } })}
          />
        </label>
        <label className="field">
          <span>مدت جلسهٔ تمرکز (دقیقه)</span>
          <input
            className="input" type="number" min={5} max={120} step={5} value={s.focusDurationMin}
            onChange={(e) => dispatch({ type: "setSettings", patch: { focusDurationMin: Math.max(5, Number(e.target.value) || 25) } })}
          />
        </label>
        <label className="switch">
          <input
            type="checkbox" checked={s.reduceMotion}
            onChange={(e) => dispatch({ type: "setSettings", patch: { reduceMotion: e.target.checked } })}
          />
          <span>کاهش حرکت — انیمیشن‌ها متوقف می‌شوند</span>
        </label>
      </section>

      <section className="block">
        <h2>وضعیت</h2>
        <ul className="kv">
          <li><span>محیط</span><b>{isTelegram() ? `مینی‌اپ تلگرام (${platformName()})` : "وب"}</b></li>
          <li><span>ذخیره‌سازی</span><b>{import.meta.env.VITE_API_BASE ? "سرور" : "محلی (این دستگاه)"}</b></li>
          {tgUser && <li><span>کاربر تلگرام</span><b>{tgUser.first_name} {tgUser.last_name ?? ""}</b></li>}
        </ul>
        {!import.meta.env.VITE_API_BASE && (
          <p className="hint">
            داده‌ها فعلاً فقط روی همین مرورگر ذخیره می‌شوند. با اتصال بک‌اند، بین دستگاه‌ها سینک می‌شود.
          </p>
        )}
        <Btn
          variant="quiet"
          onClick={() => {
            if (confirm("همهٔ داده‌های این دستگاه پاک شود؟")) {
              localStorage.removeItem("soheil.state.v1");
              location.reload();
            }
          }}
        >
          پاک کردن دادهٔ این دستگاه
        </Btn>
      </section>
    </div>
  );
}
